import React from 'react';
import { Paper, Grid, Box, Typography } from '@material-ui/core';

import useStyles from './styles';
import useBooking from '../../../../context/useBooking';
import { useTranslations } from 'components/utilities';

const BookingDetailsCar = ({ boxPaddings, isDesktop }) => {
	const { t } = useTranslations();
	const classes = useStyles();

	const { booking } = useBooking();

	return (
		<Paper>
			<Box {...boxPaddings}>
				<Typography variant="h5" color="primary">
					{t('booking.carDetails')}
				</Typography>
				<Box pt={2}>
					<Grid
						container
						spacing={10}
						justify="space-between"
						direction={isDesktop ? 'row' : 'column'}
					>
						<Grid item xs={12} md={6}>
							<Box display="flex" flexDirection="column" minHeight="100%">
								<Typography variant="h2" className={classes.carName}>
									{booking?.car?.name}
								</Typography>
								<Typography variant="h4">{booking?.car?.year}</Typography>
								<Box pt={1} mt="auto">
									<img
										src={booking?.car?.office?.logo}
										alt="Office"
										className={classes.officeImage}
									/>
								</Box>
							</Box>
						</Grid>
						<Grid item xs={12} md={6}>
							<img
								src={booking?.car?.image}
								alt="Car"
								className={classes.carImage}
							/>
						</Grid>
					</Grid>
				</Box>
			</Box>
		</Paper>
	);
};

export default BookingDetailsCar;
